(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/login-iam/assets/javascripts/utils/iam-iframe-eid-app-handler.js') >= 0) return;  svs.modules.push('/modules/login-iam/assets/javascripts/utils/iam-iframe-eid-app-handler.js');

'use strict';

if (svs.accountservices.check_iam.isIamIFrameEnabled) {
  const updateQuerystringWithParamAndValue = (param, value) => {
    svs.utils.url.refreshQueryString();
    let targetPath = svs.utils.url.currentPathEncodedParams();
    targetPath = svs.utils.url.updateQueryStringParameter(targetPath, param, value);
    window.history.replaceState({}, '', targetPath);
  };

  const handleIOS = () => {
    var _navigator, _svs;
    const userAgent = ((_navigator = navigator) === null || _navigator === void 0 || (_navigator = _navigator.userAgent) === null || _navigator === void 0 ? void 0 : _navigator.toLowerCase()) || '';
    const isNativeApp = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.svsconfig) === null || _svs === void 0 ? void 0 : _svs.isNativeApp;
    if (isNativeApp) {
      return encodeURIComponent(window.location.href.replace(/https?/i, 'spelbutiken.bankid'));
    } else if (userAgent.indexOf('firefox') > -1 || userAgent.indexOf('fxios') > -1) {
      return encodeURIComponent('firefox://');
    } else if (userAgent.indexOf('edge') > -1 || userAgent.indexOf('edg') > -1 || userAgent.indexOf('edgios') > -1) {
      if (window.location.protocol.indexOf('s') > -1) {
        return 'microsoft-edge-https://';
      }
      return 'microsoft-edge-http://';
    } else if (userAgent.indexOf('safari') > -1) {
      return encodeURIComponent(svs.utils.url.currentUrlEncodedParams());
    }
    return 'null'; 
  };

  const getReturnUrlForEidApp = () => {
    var _svs2, _navigator2;
    const isNativeApp = (_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.core) === null || _svs2 === void 0 || (_svs2 = _svs2.config) === null || _svs2 === void 0 || (_svs2 = _svs2.data) === null || _svs2 === void 0 || (_svs2 = _svs2.svsconfig) === null || _svs2 === void 0 ? void 0 : _svs2.isNativeApp;
    const userAgentFamily = ((_navigator2 = navigator) === null || _navigator2 === void 0 || (_navigator2 = _navigator2.userAgent) === null || _navigator2 === void 0 ? void 0 : _navigator2.toLowerCase()) || '';
    let returnUrl;
    if (svs.core.detect.browser.crios()) {
      if (window.location.protocol.indexOf('s') > -1) {
        returnUrl = 'googlechromes://';
      } else {
        returnUrl = 'googlechrome://';
      }
    } else if (svs.core.detect.os.iOS()) {
      const isNativePokerLogin = Boolean(svs.utils.cookie.read('is-native-poker-login'));
      if (isNativePokerLogin) {
        returnUrl = encodeURIComponent('svenskaspel-poker://');
      } else if (isNativeApp) {
        returnUrl = encodeURIComponent(window.location.href.replace(/https?/i, 'spelbutikenlb.bankid'));
      } else if (userAgentFamily.indexOf('firefox') > -1 || userAgentFamily.indexOf('fxios') > -1) {
        const url = svs.utils.url.currentUrlEncodedParams();
        returnUrl = encodeURIComponent("firefox://open-url?url=".concat(url));
      } else if (userAgentFamily.indexOf('ios') > -1 || userAgentFamily.indexOf('safari') > -1) {
        const url = svs.utils.url.currentUrlEncodedParams();
        returnUrl = encodeURIComponent(url);
      } else {
        returnUrl = 'null';
      }
    } else {
      returnUrl = 'null';
    }
    return returnUrl;
  };
  svs.login_iam.utils.iamIframeEidAppHandler = {
    getReturnUrlForEidApp
  };
}

 })(window);